// useEffect(()=>{
// fetchReports()
// },[filterDate.endDate])

// const fetchReports = async ()=>{
//   let res = await getDashboardReportFrontApi(filterDate)
//   console.log(res.data,"reponse of dash")
// }
import React, { useEffect, useState } from "react";
import { Calendar, Users, Building2, ShoppingCart, Tag, TrendingUp, TrendingDown } from "lucide-react";
import { getDashboardReportFrontApi } from "../services/reports";

// Mock data for demonstration
const mockDashboardData = {
  companiesJoined: 45,
  brandsJoined: 128,
  totalUsers: 12534,
  totalOrders: 8976,
  previousPeriod: {
    companiesJoined: 38,
    brandsJoined: 115,
    totalUsers: 11890,
    totalOrders: 8124
  }
};

const MetricCard = ({ title, value, icon: Icon, trend, trendValue, color = "blue" }) => {
  const colorClasses = {
    blue: "bg-blue-50 border-blue-200 text-blue-900",
    green: "bg-green-50 border-green-200 text-green-900",
    purple: "bg-purple-50 border-purple-200 text-purple-900",
    orange: "bg-orange-50 border-orange-200 text-orange-900"
  };

  const iconColorClasses = {
    blue: "text-blue-600",
    green: "text-green-600",
    purple: "text-purple-600",
    orange: "text-orange-600"
  };

  return (
    <div className={`p-6 rounded-lg border-2 ${colorClasses[color]} transition-all duration-200 hover:shadow-md`}>
      <div className="flex items-center justify-between mb-4">
        <div className={`p-3 rounded-full bg-white ${iconColorClasses[color]}`}>
          <Icon size={24} />
        </div>
        {trend && (
          <div className={`flex items-center text-sm ${trend === 'up' ? 'text-green-600' : 'text-red-600'}`}>
            {trend === 'up' ? <TrendingUp size={16} /> : <TrendingDown size={16} />}
            <span className="ml-1">{trendValue}%</span>
          </div>
        )}
      </div>
      <div>
        <p className="text-sm font-medium opacity-70 mb-1">{title}</p>
        <p className="text-3xl font-bold">{value?.toLocaleString()}</p>
      </div>
    </div>
  );
};

const DateRangePicker = ({ startDate, endDate, onDateChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [tempStartDate, setTempStartDate] = useState(startDate);
  const [tempEndDate, setTempEndDate] = useState(endDate);

  const formatDate = (date) => {
    if (!date) return '';
    const d = new Date(date);
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    const year = d.getFullYear();
    return `${month}-${day}-${year}`;
  };

  const handleApply = () => {
    if (tempStartDate && tempEndDate) {
      onDateChange(formatDate(tempStartDate), formatDate(tempEndDate));
      setIsOpen(false);
    }
  };

  const getDisplayText = () => {
    if (startDate && endDate) {
      return `${startDate} - ${endDate}`;
    }
    return "Select Date Range";
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-2 px-4 py-2 border border-gray-300 rounded-lg hover:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
      >
        <Calendar size={18} />
        <span>{getDisplayText()}</span>
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 p-4 bg-white border border-gray-300 rounded-lg shadow-lg z-10 min-w-80">
          <div className="grid grid-cols-2 gap-4 mb-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Start Date</label>
              <input
                type="date"
                value={tempStartDate}
                onChange={(e) => setTempStartDate(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">End Date</label>
              <input
                type="date"
                value={tempEndDate}
                onChange={(e) => setTempEndDate(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>
          <div className="flex justify-end space-x-2">
            <button
              onClick={() => setIsOpen(false)}
              className="px-4 py-2 text-gray-600 hover:text-gray-800"
            >
              Cancel
            </button>
            <button
              onClick={handleApply}
              className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
            >
              Apply
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default function Home() {
  const today = new Date().toISOString().split('T')[0];
  const [reports, setReports] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [filterDate, setFilterDate] = useState({
    startDate: today,
    endDate: today
  });
useEffect(()=>{
fetchReports()
},[filterDate.endDate])

const fetchReports = async ()=>{
  let res = await getDashboardReportFrontApi(filterDate)
  console.log(res.data,"reponse of dash")
  setReports(res?.data)
}
  // Function to format date to MM-DD-YYYY for API
  const formatDateForAPI = (date) => {
    if (!date) return null;
    const d = new Date(date);
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    const year = d.getFullYear();
    return `${month}-${day}-${year}`;
  };

  // Calculate trend from API trends data
  const getTrendInfo = (trendValue) => {
    return {
      trend: trendValue >= 0 ? 'up' : 'down',
      value: Math.abs(trendValue)
    };
  };

  const getReports = async () => {
    setLoading(true);
    setError(null);
    try {
      // Format dates for API call
      const apiDateFilter = {
        startDate: formatDateForAPI(filterDate.startDate),
        endDate: formatDateForAPI(filterDate.endDate)
      };

      // Uncomment this when your API is ready
      // const res = await getDashReport(apiDateFilter);
      // if (res?.success && res?.data) {
      //   setReports(res.data);
      // } else {
      //   setError('Failed to fetch dashboard data');
      // }
      
      // Mock API response for testing - remove this when API is ready
      // setTimeout(() => {
      //   const mockApiResponse = {
      //     metrics: {
      //       companiesJoined: 0,
      //       brandsJoined: 0,
      //       totalUsers: 0,
      //       totalOrders: 0,
      //       totalRevenue: 0,
      //       averageOrderValue: 0,
      //     },
      //     trends: {
      //       companiesJoinedTrend: 0,
      //       brandsJoinedTrend: 0,
      //       totalUsersTrend: 0,
      //       totalOrdersTrend: 0,
      //     },
      //     previousPeriod: {
      //       companiesJoined: 0,
      //       brandsJoined: 0,
      //       totalUsers: 0,
      //       totalOrders: 0,
      //     },
      //     analytics: {
      //       averageUsersPerCompany: 0,
      //       averageOrdersPerUser: 0,
      //       brandsPerCompany: 0
      //     },
      //     dateRange: {
      //       startDate: filterDate.startDate,
      //       endDate: filterDate.endDate,
      //       periodDays: 0
      //     }
      //   };
      //   setReports(mockApiResponse);
      //   setLoading(false);
      // }, 800);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching reports:', error);
      setError('Error loading dashboard data');
      setLoading(false);
    }
  };

  const handleDateChange = (startDate, endDate) => {
    setFilterDate({
      startDate,
      endDate
    });
  };

  useEffect(() => {
    getReports();
  }, [filterDate]);

  // Get trend information from API response
  const companiesTrend = reports ? getTrendInfo(reports.trends?.companiesJoinedTrend || 0) : { trend: 'up', value: 0 };
  const brandsTrend = reports ? getTrendInfo(reports.trends?.brandsJoinedTrend || 0) : { trend: 'up', value: 0 };
  const usersTrend = reports ? getTrendInfo(reports.trends?.totalUsersTrend || 0) : { trend: 'up', value: 0 };
  const ordersTrend = reports ? getTrendInfo(reports.trends?.totalOrdersTrend || 0) : { trend: 'up', value: 0 };

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex justify-between items-center mb-8">
          <div>
            <h1 className="text-3xl font-bold text-gray-900">Dashboard Overview</h1>
            <p className="text-gray-600 mt-1">
              {filterDate.startDate === filterDate.endDate 
                ? `Data for ${filterDate.startDate}`
                : `Data from ${filterDate.startDate} to ${filterDate.endDate}`
              }
            </p>
          </div>
          <DateRangePicker
            startDate={filterDate.startDate}
            endDate={filterDate.endDate}
            onDateChange={handleDateChange}
          />
        </div>

        {/* Loading State */}
        {loading && (
          <div className="flex justify-center items-center py-12">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
          </div>
        )}

        {/* Error State */}
        {error && !loading && (
          <div className="flex justify-center items-center py-12">
            <div className="text-center">
              <p className="text-red-600 mb-4">{error}</p>
              <button
                onClick={getReports}
                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
              >
                Retry
              </button>
            </div>
          </div>
        )}

        {/* Metrics Grid */}
        {!loading && !error && reports && (
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6">
            <MetricCard
              title="Companies Joined"
              value={reports.metrics?.companiesJoined || 0}
              icon={Building2}
              trend={companiesTrend.trend}
              trendValue={companiesTrend.value}
              color="blue"
            />
            <MetricCard
              title="Brands Joined"
              value={reports.metrics?.brandsJoined || 0}
              icon={Tag}
              trend={brandsTrend.trend}
              trendValue={brandsTrend.value}
              color="purple"
            />
            <MetricCard
              title="Total Users"
              value={reports.metrics?.totalUsers || 0}
              icon={Users}
              trend={usersTrend.trend}
              trendValue={usersTrend.value}
              color="green"
            />
            <MetricCard
              title="Total Orders"
              value={reports.metrics?.totalOrders || 0}
              icon={ShoppingCart}
              trend={ordersTrend.trend}
              trendValue={ordersTrend.value}
              color="orange"
            />
          </div>
        )}

        {/* Summary Section */}
        {!loading && !error && reports && (
          <div className="mt-8 bg-white rounded-lg border border-gray-200 p-6">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">Period Summary</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 text-sm">
              <div className="text-center p-4 bg-gray-50 rounded-lg">
                <p className="text-gray-600">Avg. Users per Company</p>
                <p className="text-2xl font-semibold text-gray-900">
                  {reports.analytics?.averageUsersPerCompany || 0}
                </p>
              </div>
              <div className="text-center p-4 bg-gray-50 rounded-lg">
                <p className="text-gray-600">Avg. Orders per User</p>
                <p className="text-2xl font-semibold text-gray-900">
                  {reports.analytics?.averageOrdersPerUser || '0.0'}
                </p>
              </div>
              <div className="text-center p-4 bg-gray-50 rounded-lg">
                <p className="text-gray-600">Brands per Company</p>
                <p className="text-2xl font-semibold text-gray-900">
                  {reports.analytics?.brandsPerCompany || '0.0'}
                </p>
              </div>
              <div className="text-center p-4 bg-gray-50 rounded-lg">
                <p className="text-gray-600">Total Revenue</p>
                <p className="text-2xl font-semibold text-green-600">
                  ${(reports.metrics?.totalRevenue || 0).toLocaleString()}
                </p>
              </div>
            </div>

            {/* Additional Revenue Metrics */}
            {reports.metrics?.totalRevenue > 0 && (
              <div className="mt-6 pt-6 border-t border-gray-200">
                <h3 className="text-lg font-medium text-gray-900 mb-3">Revenue Insights</h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
                  <div className="text-center p-3 bg-blue-50 rounded-lg">
                    <p className="text-blue-600 font-medium">Average Order Value</p>
                    <p className="text-xl font-semibold text-blue-900">
                      ${reports.metrics?.averageOrderValue || 0}
                    </p>
                  </div>
                  <div className="text-center p-3 bg-green-50 rounded-lg">
                    <p className="text-green-600 font-medium">Revenue per User</p>
                    <p className="text-xl font-semibold text-green-900">
                      ${reports.metrics?.totalUsers > 0 
                        ? Math.round(reports.metrics.totalRevenue / reports.metrics.totalUsers)
                        : 0}
                    </p>
                  </div>
                  <div className="text-center p-3 bg-purple-50 rounded-lg">
                    <p className="text-purple-600 font-medium">Revenue per Company</p>
                    <p className="text-xl font-semibold text-purple-900">
                      ${reports.metrics?.companiesJoined > 0 
                        ? Math.round(reports.metrics.totalRevenue / reports.metrics.companiesJoined)
                        : 0}
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}